module.exports = __webpack_public_path__ + "static/img/icon-pulsar.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-pulsar.png
// module id = d4uY
// module chunks = 0